<div class="col-lg-12">
    <div class="card ui-cards mt-3">
        <div class="card-body">
            <div class="mb-3 d-flex justify-content-between align-center">
                <h5 class="mb-0">
                    <b>
                        Migrate
                    </b>
                </h5>
                <div>
                    Balance - {{isEthereumNetwork ? v1Balance : 0}} {{symbol}}
                </div>
            </div>
            <div class="transh-section">
            <div class="w-100 polka-v1">
                <div>
                    <img src="assets/images/Blockchain_icon_blue.png" alt="" width="15%">
                </div>
                <b>
                    {{symbol}}
                </b> <span>(use whole numbers eg: 100 instead of 100.12345) &nbsp;</span>
                <button class="btn btn-outline-secondary max-btn" (click)="setMax(v1Balance)" type="button" id="button-addon3">MAX</button>
            </div>
            <div class="input-group mb-3">
                <input type="number" class="form-control" id="floatingInput" min="0"  pattern="^[0-9]*$" oninput="this.value = this.value.replace(/\.|\D/g, '');" placeholder="0" (keyup)="changeMigrationAmount($event)" [value]="migrationAmount">
            </div>
            <div class="input-group mb-3" *ngIf="!isEthereumNetwork && account.address">
                <button (click)="changeNetwork()" type="button" class="btn btn-dark w-100" >
                    Connect to Ethereum network
                </button>
            </div>      
            <div class="input-group mb-3" *ngIf="!account.address">
                <button class="btn btn-dark w-100" (click)="connectWallet()"> Connect Wallet </button>
            </div>
            <div class="input-group mb-3" *ngIf="isEthereumNetwork && migrationAmount > 0 && !isApproved">
                <ng-container *ngIf="v1Balance >= migrationAmount; else balanceError">
                <button type="button" [disabled]="isResponsive" class="btn btn-polka w-100 d-flex justify-content-center" (click)="approve()">
                    <div *ngIf="isResponsive" class="loader"> </div> <span *ngIf="!isResponsive" > Approve {{migrationAmount}} {{symbol}}</span>
                    <span *ngIf="isResponsive">&nbsp;Approving… Please wait!</span>
                </button>
            </ng-container>
            <ng-template #balanceError>
                <span class="balance-error">
                    Insufficient balance
                </span>
            </ng-template>
            </div>
            <div class="input-group" *ngIf="isEthereumNetwork">
                <button type="button" class="btn btn-polka w-100 d-flex justify-content-center" [disabled]="isLoading" [disabled]="!isApproved || v1Balance == 0" (click)="migrate()">
                    <div *ngIf="isLoading" class="loader"></div> <span *ngIf="!isLoading" > Migrate </span>
                    <span *ngIf="isLoading">&nbsp;Migrating... Please wait!</span>
                </button>
            </div>
        </div>
        </div>
    </div>
</div>

<app-migration-transactions [transactions]="migrationTransactions"></app-migration-transactions>
